export const getBookButtonTitle = (canBeBooked: boolean): string => {
  return canBeBooked ? 'Забронировать' : 'Проверить даты';
};
